module.exports = __webpack_public_path__ + "img/5.8adebfa1.png";